<template>
  <div class="section-card">
    <v-row class="section-title mb-0 mt-3 pa-0" no-gutters>
      <v-col cols="6" sm="3" class="pt-4 pl-5">
        Planes de cobros:
        <a class="btn btn-default" data-toggle="collapse" href="#collapseplanes">expandir</a>
      </v-col>
      <v-col cols="6" sm="9">
        <v-combobox v-model="templatexselLocal" :items="templates" :loading="loadingtemplates"
          :disabled="onlyReadConta" item-text="nombre" color="#1e3a8a"
          label="Agregar plan de pagos predefinido" class="ma-4" hide-details dark dense outlined />
      </v-col>
    </v-row>

    <div class="collapse section-body" id="collapseplanes">
      <v-alert v-if="planes && planes.length > 0" type="info" outlined class="mt-4 ml-2 mr-2">
        <p class="my-0"><b>AVISO:</b> No puede crear nuevos planes, solicite a la nacional la creación de un nuevo plan y use la opción "agregar plan de pagos predefinido".</p>
        <small class="red--text">Use punto decimal para valores fraccionados, máximo 2 decimales.</small>
      </v-alert>

      <div class="row pb-0 mr-2 ml-1" v-for="(c, ind) in planes" :key="ind + '--'">
        <div class="col bg-info">
          <input type="text" :disabled="c.xedit == false" v-model.trim="c.nombre" class="form-control" placeholder="nombre..." />
          <label><small><span class="text-danger">*</span> Nombre del plan</small></label>
        </div>

        <div v-if="c.plan_cobro_programa_id" class="col col-sm-1 col-lg-1 text-center bg-info">
          <input type="checkbox" v-model="c.estado" :disabled="onlyReadConta" class="form-control" style="height:1.6em" />
          <label><small>estado</small></label>
        </div>

        <div v-if="c.plan_cobro_programa_id" class="col col-sm-3 col-lg-2 bg-info">
          <input type="datetime" v-model.trim="c.fecha_registro" disabled class="form-control" />
          <label><small><span class="text-danger">*</span> Fecha registro del plan</small></label>
        </div>

        <div v-if="c.aprobado" class="col col-sm-2 col-lg-1 text-center bg-info">
          <input type="checkbox" v-model="c.aprobado" :disabled="true" class="form-control" style="height:1.6em" />
          <label><small>Aprobado</small></label>
        </div>
        <div v-else-if="c.plan_cobro_programa_id" class="col col-sm-2 col-lg-2 text-center bg-info">
          <v-btn v-if="$store.state.CARGO.id == 14" small color="red" dark @click="$emit('aprobar-plan', c)">Aprobar Plan</v-btn>
          <span v-else>Nac. conta. aprueba</span>
        </div>

        <div class="col col-sm-12" v-if="c.estado">
          <div class="row" v-for="(co, indd) in c.cobros" :key="indd">
            <div v-if="c.plan_cobro_programa_id" class="col col-lg-6 col-sm-4" style="padding-top:0;padding-bottom:0">
              <v-text-field dense outlined label="* Nombre del concepto:" v-model.trim="co.nombre" :readonly="true" />
            </div>
            <div v-else class="col col-lg-6 col-sm-4" style="padding-top:0;padding-bottom:0">
              <select v-model.number="co.concepto_pago_id" class="form-control" :disabled="co.xedit == false">
                <option v-for="(cnp, idx) in conceptos" :key="idx" :value="cnp.id">{{ cnp.nombre }}</option>
              </select>
              <label><small><span class="text-danger">*</span> Seleccione el concepto</small></label>
            </div>
            <div class="col col-sm-3 col-lg-2" style="margin:0!important;padding-top:0;padding-bottom:0">
              <v-text-field dense outlined label="* Monto" type="number" v-model.number="co.monto"
                @keyup="$emit('redondear', co, 'monto')" :readonly="!!c.plan_cobro_programa_id" />
            </div>
            <div class="col col-sm-2 col-lg-2" style="margin:0!important;padding-top:0;padding-bottom:0">
              <v-text-field dense outlined label="* Cuotas" type="number" v-model.number="co.cuotas"
                :readonly="!!c.plan_cobro_programa_id" />
            </div>
          </div>

          <div class="text-right" v-if="!c.plan_cobro_programa_id && c.xedit != false">
            <button type="button" class="btn btn-sm btn-warning white--text" @click="$emit('quitar-concepto', c)">- quitar concepto</button>
            <button type="button" class="btn btn-sm btn-success white--text" @click="$emit('agregar-concepto', c)">+ agregar concepto</button>
          </div>
        </div>
        <div class="col col-sm-12 pt-0 pl-0 pr-0" v-else>
          <p class="text-center bg-danger text-danger mb-12 mt-0 pt-0">Este plan tiene el estado desactivado.</p>
        </div>
        <div class="col col-sm-12 ma-0 pa-0"><hr /></div>
      </div>

      <div>
        <button v-if="planes && planes.length > 0" type="button" :disabled="onlyReadConta"
          class="btn btn-sm btn-danger white--text" @click="$emit('quitar-plan')">- quitar plan</button>
        <button v-if="$store.state.DATA_USER.id == 14 || $store.state.CARGO.id == 100"
          type="button" class="btn btn-sm btn-success white--text" @click="$emit('agregar-plan')">+ agregar plan</button>
        <v-alert v-else type="info" outlined>
          <p class="my-0"><b>AVISO:</b> No puede crear nuevos planes, solicite a la nacional.</p>
        </v-alert>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SeccionPlanes',
  props: {
    planes: { type: Array, default: () => [] },
    templates: { type: Array, default: () => [] },
    conceptos: { type: Array, default: () => [] },
    loadingtemplates: { type: Boolean, default: false },
    onlyReadConta: { type: Boolean, default: false },
  },
  data() {
    return { templatexselLocal: null };
  },
  watch: {
    templatexselLocal(val) {
      if (val && val.tipo_plan_id) this.$emit('template-selected', val);
    },
  },
};
</script>

<style scoped>
.section-card { background:#fff; border:1px solid #e6e9f0; border-radius:12px; padding:14px 14px 6px; margin-top:16px; box-shadow:0 4px 12px rgba(0,0,0,.04); }
.section-title { border-radius:10px; background:linear-gradient(90deg,#e3f2fd 0%,#ede7f6 100%); color:#1e3a8a; font-weight:600; }
.section-body { padding-top:10px; }
</style>
